
import cornerstoneTools from "cornerstone-tools";
export default class LiewenTool extends cornerstoneTools.EllipticalRoiTool {
    private createNewMeasurement(eventData) {
        return {
            visible: true,
            active: true,
            color: 'red',
            invalidated: true,
            handles: {
                start: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: false
                },
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true
                },
                initialRotation: eventData.viewport.rotation,
                textBox: {
                    active: false,
                    hasMoved: false,
                    movesIndependently: false,
                    drawnIndependently: true,
                    allowedOutsideImage: true,
                    hasBoundingBox: true
                }
            }
        };
    }
    // private pointNearTool() {
    //     return true;
    // }
}
